import type { ScreeningSource } from "../types";

export const mapStatus = {
  "Solicitud recibida": "pending",
  Preaprobado: "preApproved",
  "En estudio": "inReview",
  Aprobado: "approved",
  "No viable": "rejected",
  Afianzado: "contracted",
} as const;

export const mapPropertyUse = {
  Vivienda: "residential",
  Comercio: "commercial",
} as const;

export const mapDocumentType = {
  CC: "cc",
  CE: "ce",
  NIT: "nit",
  PS: "ps",
} as const;

export const mapPropertyType = {
  Apartaestudio: "studio",
  Apartamento: "apartment",
  Casa: "house",
  "Casa campestre": "countryHouse",
  Finca: "farm",
  Habitación: "room",
  Bodega: "warehouse",
  "Casa comercial": "commercialHouse",
  Consultorio: "medicalOffice",
  Edificio: "building",
  Local: "commercialSpace",
  Lote: "lot",
  Oficina: "office",
  Otro: "other",
} as const;

export const mapOccupation = {
  Empleado: "employee",
  Independiente: "independent",
  Pensionado: "retired",
  Estudiante: "student",
} as const;

export const mapSource = {
  "Agente IA": "rentalsAgent",
  "Formulario de estudio": "tenantPortal",
  Inducción: "paymentHistory",
  Analista: "analyst",
} as const;

const reverse = <T extends Record<string, string>>(map: T) =>
  Object.fromEntries(
    Object.entries(map).map(([label, value]) => [value, label])
  ) as { [K in keyof T as T[K]]: K };

export const statusLabels = reverse(mapStatus);
export const propertyUseLabels = reverse(mapPropertyUse);
export const documentTypeLabels = reverse(mapDocumentType);
export const occupationLabels = reverse(mapOccupation);
export const propertyTypeLabels = reverse(mapPropertyType);
export const sourceLabels: Record<ScreeningSource, string> = reverse(mapSource);

export type ScreeningStatus = (typeof mapStatus)[keyof typeof mapStatus];
export type ScreeningDocumentType =
  (typeof mapDocumentType)[keyof typeof mapDocumentType];

export const documentLabel = (
  documentType: ScreeningDocumentType | undefined,
  documentNumber: string
) =>
  documentType
    ? `${documentTypeLabels[documentType]} ${documentNumber}`
    : documentNumber;

export const personType = (documentType?: ScreeningDocumentType) => {
  if (!documentType) return undefined;
  return documentType === "nit" ? "PJ" : "PN";
};
